import axiosClient from './client'

export const createFundraiserAccount = (userId, stripeAuthorizationCode) => (
  axiosClient().post(`/users/${userId}/fundraiser_accounts`, { stripeAuthorizationCode })
)
